import EnUs from './en-US.webp'
import EsEs from './es-ES.webp'
// Added new SVG — run `npx svgo -f src/components_new/Icon/icons`

export const localeIcons = {
    'en-US': EnUs,
    'es-ES': EsEs,
}
